import React from "react";
import { connect } from "react-redux";
import { FiCheck, FiX } from "react-icons/fi";
import { withTranslation } from "react-i18next";

class PdfBulkResultsTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			uploadResults: props.results || []
		};
	}

	componentDidUpdate(prevProps) {
		// Si cambian los resultados, actualizar el estado
		if (prevProps.results !== this.props.results) {
			this.setState({ uploadResults: this.props.results || [] });
		}
	}

	clearResults = () => {
		// Llamar a la función del componente padre para limpiar los resultados
		if (this.props.onClearResults) {
			this.props.onClearResults();
		}
	};

	renderResultsTable = () => {
		const { uploadResults } = this.state;
		const { t } = this.props;

		if (!uploadResults || !Array.isArray(uploadResults) || uploadResults.length === 0) {
			return null;
		}

		const successCount = uploadResults.filter(result => result.status === "SUCCESS").length;
		const errorCount = uploadResults.filter(result => result.status === "ERROR").length;

		return (
			<div className="upload-results-container">
				<div className="results-header">
					<div className="results-summary">
						<h4>{t("documents.bulk.pdfResults")}</h4>
						<div>
							<span className="success">
								<FiCheck style={{ marginRight: '5px' }} />
								{t("documents.bulk.successCount", { count: successCount })}
							</span>
							<span className="error">
								<FiX style={{ marginRight: '5px' }} />
								{t("documents.bulk.errorCount", { count: errorCount })}
							</span>
						</div>
					</div>
					<div className="results-actions">
						<button
							type="button"
							onClick={this.clearResults}
							className="btn btn-outline-secondary"
						>
							{t("common.close")}
						</button>
					</div>
				</div>

				<table className="table table-documents table-zebra">
					<thead>
						<tr>
							<th>{t("documents.columns.document")}</th>
							<th>{t("documents.columns.status")}</th>
							<th>{t("documents.columns.description")}</th>
						</tr>
					</thead>
					<tbody>
						{uploadResults.map((result, index) => (
							<tr key={index}>
								<td>
									<span className="document-name">
										{result.file_name}
									</span>
								</td>
								<td>
									{result.status === "SUCCESS" ? (
										<span className="status-success">
											<FiCheck style={{ marginRight: '5px' }} />
											{t("documents.success")}
										</span>
									) : (
										<span className="status-error">
											<FiX style={{ marginRight: '5px' }} />
											{t("common.error")}
										</span>
									)}
								</td>
								<td>
									{result.status === 'SUCCESS' ? (
										<span className="text-success font-weight-bold">
											{result.error_description}
										</span>
									) : (
										<span className="text-danger">
											{result.error_description === 'store_folder.employee_not_found'
												? t("documents.employeeNotFound")
												: result.error_description}
										</span>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	};

	renderEmptyState = () => {
		const { t } = this.props;
		return (
			<div className="empty-state-container">
				<div className="empty-state-icon-circle">
					<FiCheck size={40} color="#6c757d" />
				</div>
				<h3>{t("documents.bulk.noPdfResults")}</h3>
				<p>{t("documents.bulk.pdfResultsWillAppear")}</p>
			</div>
		);
	};

	render() {
		const { uploadResults } = this.state;
		
		return (
			<div className="documents-bulk-list">
				{uploadResults && uploadResults.length > 0 ? this.renderResultsTable() : this.renderEmptyState()}
			</div>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		// Aquí puedes agregar cualquier estado que necesites del Redux
	};
};

const mapDispatchToProps = (dispatch) => ({
	// Aquí puedes agregar cualquier acción que necesites despachar
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PdfBulkResultsTable)); 